import type { ISource } from '../models';

// TODO: В будущем — убрать `?`
// Пропс `sources` использует Элвис-оператор, т.к. в `acms` много случаев использования ResponsiveBackground без `sources`
export const findBackgroundByMedia = (sources?: ISource[]) =>
    sources?.find(source => window.matchMedia(source.media || '').matches);
